import fishbowlService from '../../services/fishbowl';

export default {
  state: {
    fishbowlSalesOrder: {},
    fishbowlSearchResults: [],
    fishbowlAwaitingPayment: [],
    fishbowlOrderPipeline: [],
    fishbowlRmahcShipOptions: [],
    fishbowlPayments: [],
    fishbowlHcTypes: [],
  },

  getters: {
    fishbowlSalesOrder: state => state.fishbowlSalesOrder,
    fishbowlSearchResults: state => state.fishbowlSearchResults,
    fishbowlAwaitingPayment: state => state.fishbowlAwaitingPayment,
    fishbowlOrderPipeline: state => state.fishbowlOrderPipeline,
    fishbowlRmahcShipOptions: state => state.fishbowlRmahcShipOptions,
    fishbowlPayments: state => state.fishbowlPayments,
    fishbowlHcTypes: state => state.fishbowlHcTypes,
  },

  mutations: {
    SET_FISHBOWL_ORDER(state, salesOrder) {
      state.fishbowlSalesOrder = salesOrder;
    },
    SET_FISHBOWL_SEARCH_RESULTS(state, searchResults) {
      state.fishbowlSearchResults = searchResults;
    },
    SET_FISHBOWL_AWAITING_PAYMENT(state, awaitingPayment) {
      state.fishbowlAwaitingPayment = awaitingPayment;
    },
    SET_FISHBOWL_ORDER_PIPELINE(state, orderPipeline) {
      state.fishbowlOrderPipeline = orderPipeline;
    },
    SET_FISHBOWL_RMAHC_SHIP_OPTIONS(state, options) {
      state.fishbowlRmahcShipOptions = options;
    },
    SET_FISHBOWL_HC_TYPES(state, options) {
      state.fishbowlHcTypes = options;
    },
    SET_FISHBOWL_PAYMENTS(state, payments) {
      state.fishbowlPayments = payments;
    },
    CLEAR_FISHBOWL_SEARCH_RESULTS(state) {
      state.fishbowlSearchResults = [];
    },
    CLEAR_FISHBOWL_ORDER(state) {
      state.fishbowlSalesOrder = {};
    },
  },

  actions: {
    getFishbowlOrder: ({ commit }, orderNumber) => {
      fishbowlService.getSalesOrder(orderNumber).then((response) => {
        commit('SET_FISHBOWL_ORDER', response);
      });
    },
    searchFishbowlForOrders: ({ commit }, payload) => {
      return new Promise( (resolve, reject) => {
        fishbowlService.searchOrder(payload).then((response) => {
          commit('SET_FISHBOWL_SEARCH_RESULTS', response);
          resolve(response);
        }).catch( err => { console.error(err); reject(err)} );
      });
    },
    getFishbowlAwaitingPayment: ({ commit }) => {
      fishbowlService.getAwaitingPayment().then((response) => {
        commit('SET_FISHBOWL_AWAITING_PAYMENT', response);
      });
    },
    getFishbowlOrderPipeline: ({ commit }) => {
      fishbowlService.getOrderPipeline().then((response) => {
        commit('SET_FISHBOWL_ORDER_PIPELINE', response);
      });
    },
    getFishbowlPayments: ({ commit }, num) => {
      fishbowlService.getPayments(num).then((response) => {
        commit('SET_FISHBOWL_PAYMENTS', response)
      })
    },
    clearFishbowlSearchResults: ({ commit }) => {
      commit('CLEAR_FISHBOWL_SEARCH_RESULTS');
    },
    getFishbowlRmahcShipOptions: ({ commit }) => {
      fishbowlService.getRmahcShipOptions().then((response) => {
        commit('SET_FISHBOWL_RMAHC_SHIP_OPTIONS', response);
      });
    },
    getFishbowlHcTypes: ({ commit }) => {
      fishbowlService.getHcTypes().then((response) => {
        commit('SET_FISHBOWL_HC_TYPES', response);
      });
    },
    clearFishbowlOrder: ({ commit }) => {
      commit('CLEAR_FISHBOWL_ORDER');
    },
  },
};



// WEBPACK FOOTER //
// /src/store/modules/fishbowl.js